import { fetcher } from "@website/fetcher/fetcher";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { AIRPORTS_KEY, APIs } from "@website/ticket-ui/common/constants";
import { AirportsResponseType } from "@website/ticket-ui/common/types";

export const useDomFlightAirportsService = (query: string) => {
  const { data, isLoading } = useFetcherV2({
    queryFn: () =>
      fetcher({
        url: `${APIs.baseUrlInterFlightMainEndpoint}${APIs.Airports}`,
        params: { query, countryCode: "IR" }
      }).then(({ data }: { data: AirportsResponseType }) => data?.cities),
    queryKey: [AIRPORTS_KEY, query],
    enabled: query.length >= 3
  });

  return {
    data,
    isLoading
  };
};
